import React from 'react'

const WheelLoaderAuthorizedDealers = () => {
  return (
    <section className='bg-[#FFFFFF] sticky top-20 z-10' >
        <div className='max-w-7xl mx-auto px-6 h-[80px] sm:h-[123px] sm:px-6 lg:px-8'>
            <div className='flex items-center justify-between h-full'>
                <div className='flex flex-col items-start justify-center'>
                <img src="/images/logos/hengwang_authorized_dealers.webp" alt="Authorized Dealers" className='w-full h-full max-w-[180px] max-h-[65px] sm:max-w-[280px] sm:max-h-[80px] object-contain' />
                </div>
                <div className='flex items-center justify-center px-6 sm:px-12'>
                <img src="/images/logos/authorized_dealer_stamp_1.png" alt="Authorized Dealers Stamp" className='flex items-start w-full max-w-[70px] sm:max-w-[95px] h-full object-contain' />
                </div>
            </div>
        </div>
    </section>
  )
}

export default WheelLoaderAuthorizedDealers